<div class='modal-layer'>
    <div class='modal-content m-2 mt-5'>
        <p-float-label>
            <label [htmlFor]="'name'">الاسم</label>
            <input
                [(ngModel)]='categoryName'
                [autofocus]="true"
                [pAutoFocus]="true"
                class="min-w-full"
                id="name"
                pInputText />
        </p-float-label>
    </div>
    <div class='modal-footer flex justify-content-end'>
        <p-button
            (onClick)='closeDialog()'
            [outlined]='true'
            class='mx-2'
            icon='pi pi-times'
            label='إلغاء'
            severity='secondary'></p-button>
        <p-button
            (onClick)='save()' class='mx-2' icon='pi pi-check' label='حفظ'></p-button>
    </div>
</div>
